export const Pills = {
	selectors : {
		pillWrappers: [...document.querySelectorAll('[data-pills]')],
	},

	init() {
		const self = this;

		self.bindEvents();
	},

	bindEvents() {
		const self = this;

		self.selectors.pillWrappers.forEach(pillWrapper => {
			const pills = self.getPills(pillWrapper);
			const activePill = self.getActivePill(pillWrapper);
			const contents = self.getPillsContents(pillWrapper);


			contents.forEach(content => content.classList.remove('is-active'));
			const pillContent = self.getPillContent(activePill);
			pillContent.classList.add('is-active');


			pills.forEach(pill => {
				pill.addEventListener('click', e => {
					e.preventDefault();
					const activePill = self.getActivePill(pillWrapper);
					activePill.classList.remove('is-active');

					contents.forEach(content => content.classList.remove('is-active'));

					const pillContent = self.getPillContent(pill);
					pillContent.classList.add('is-active');
					pill.classList.add('is-active');
				});
			})
		});
	},

	getPills(wrapper) {
		return wrapper.querySelectorAll('[data-pill]');
	},

	getActivePill(wrapper) {
		return wrapper.querySelector('[data-pill].is-active');
	},

	getPillContent(pill) {
		const pillTarget = pill.getAttribute('data-pill');

		return document.querySelector('[data-pill-content="'+ pillTarget +'"]')
	},

	getPillsContents(pillWrapper) {
		return document.querySelectorAll(pillWrapper.getAttribute('data-pills') + ' [data-pill-content]');
	},
}

Pills.init();
